import { BaseXHR } from '@utils/axios';

export const getPortfolioApi = (slug: string) =>
  BaseXHR.$get('account/portfolio/get-by-slug', { slug });

export const updateViewCountByProjectsApi = (params: {
  id: string;
  project: string;
}) =>
  BaseXHR.$put('account/collectionPortfolio/updateViewCountByProjects', params);
